import React, { forwardRef } from 'react';
import {
  GDSProgressBarProps,
  ProgressBar,
} from '#components/progress-bar/progress-bar.tsx';
import { GDSCustomizableComponent } from '#src/types.ts';

const DISPLAY_NAME = 'ComposableCardProgressBar';

export interface GDSComposableCardProgressBarProps
  extends GDSCustomizableComponent {
  progressBar: GDSProgressBarProps;
}
export const ComposableCardProgressBar = forwardRef<
  HTMLDivElement,
  GDSComposableCardProgressBarProps
>(
  (
    {
      'data-testid': testId = `GDS-${DISPLAY_NAME}`,
      progressBar,
      className,
      css,
      ...props
    },
    ref?,
  ) => (
    <ProgressBar
      {...progressBar}
      className={['GDS-composable-card-progress-bar', className].join(' ')}
      css={{ flex: 0, ...css }}
      data-testid={testId}
      ref={ref}
      {...props}
    />
  ),
);

ComposableCardProgressBar.displayName = DISPLAY_NAME;
